let timer;
let minut = 60000;
let countMinuts = 20;
export const resetTimeout = (func) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(), minut * countMinuts);
}